import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInputForm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconInputForm"><Path d="M8.5 2.5C8.77614 2.5 9 2.72386 9 3V21C9 21.2761 8.77614 21.5 8.5 21.5C8.22386 21.5 8 21.2761 8 21V3C8 2.72386 8.22386 2.5 8.5 2.5Z" fill="currentColor"/><Path d="M6.5 18H4.5C3.11929 18 2 16.8807 2 15.5V8.5C2 7.11929 3.11929 6 4.5 6H6.5V18Z" fill="currentColor"/><Path d="M19.5 6C20.8807 6 22 7.11929 22 8.5V15.5C22 16.8807 20.8807 18 19.5 18H10.5V6H19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInputForm;
